import { useCallback } from 'react'

import { ReleaseDto } from '@/endpoints/models'
import { TabName } from '@/enums'
import { useAppDispatch, useAppStore } from '@/hooks'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import { findSystemNodeId } from '@/store/modules/node/helpers'
import { openTab } from '@/store/modules/tab/actions'
import { NativeMap } from '@/utils'
import { logError } from '@/utils/errorHandling'

export const useReleaseRedirect = (node: StructureDto) => {
	const dispatch = useAppDispatch()
	const nodes: NativeMap<StructureDto> = useAppStore(
		(state) => state.node.nodes,
	)

	return useCallback(
		async (release: ReleaseDto) => {
			if (!release?.id) return

			try {
				const systemId = findSystemNodeId(node, nodes)
				const systemNode = nodes[systemId] as StructureDto

				dispatch(
					openTab(systemNode, false, true, {
						id: release.id as number,
						customTabName: TabName.DeploymentPackage,
						name: release.name,
						parentNode: systemNode,
						editMode: false,
					}),
				)
			} catch (error) {
				logError(error, { operation: 'useReleaseRedirect' })
			}
		},
		[dispatch, node, nodes],
	)
}
